<template>
  <div>
    <div id="firstMenubar" class="row roundedtop menubar">
        <div class="title">Documentencentrum</div>
        <a
          v-if="style == 'db' && Number(role) === 2"
          href="https://www.doelbeleggen.nl/agenda/atp"
          target="_blank"
          class="button"
          style="float:right;"
        >
          <awesomeIcon icon="phone-alt"/> <span class="mobile-hidden">Plan een belafspraak in</span>
        </a>
        <a
          v-else-if="style=='db'"
          href="https://www.doelbeleggen.nl/content/uploads/Voorwaarden-online-machtiging-adviseur.pdf"
          target="_blank"
          class="button"
          style="float:right;"
        >
          <awesomeIcon icon="handshake"/> <span class="mobile-hidden">Lees Voorwaarden</span>
        </a>
    </div>
    <div class="card inset-small marginbottom roundedBottom" v-if="Number(role) === 2">
      <h3 class="backgroundTitle">Samen Doelbeleggen - dé portal voor adviserend Nederland</h3>
      <p style="line-height: 150%">
        U bent in het documentencentrum. Hier kunt u alle relevante documenten bekijken.
      </p>
    </div>

    <template v-if="Number(role) === 2">
      <!-- Algemene brochures en voorwaarden -->
      <div class="row titleOption">
        <h2>Algemene brochures en voorwaarden</h2>
      </div>
      <div class="container">
        <div v-for="(file, index) in brochureFiles" :key="index" class="card">
          <a
            :href="file.url"
            target="_blank"
          >
            <awesomeIcon icon="file-pdf"/>
            <h4>{{file.title}}</h4>
          </a>
        </div>
      </div>

      <!-- Lijfrentes -->
      <div class="row titleOption">
        <h2>Lijfrentes</h2>
      </div>
      <div class="container">
        <div v-for="(file, index) in annuitiesFiles" :key="index" class="card">
          <a
            :href="file.url"
            target="_blank"
          >
            <awesomeIcon icon="file-pdf"/>
            <h4>{{file.title}}</h4>
          </a>
        </div>
      </div>

      <!-- Gouden handdruk -->
      <div class="row titleOption">
        <h2>Gouden Handdruk</h2>
      </div>
      <div class="container">
        <div v-for="(file, index) in goldenHandshakeFiles" :key="index" class="card">
          <a
            :href="file.url"
            target="_blank"
          >
            <awesomeIcon icon="file-pdf"/>
            <h4>{{file.title}}</h4>
          </a>
        </div>
      </div>

    </template>
    <template v-else>
      <!-- Brochures -->
      <div class="row titleOption">
        <h2>Brochures</h2>
      </div>
      <div class="container">
        <div class="card">
          <a
            href="https://www.doelbeleggen.nl/content/uploads/Doelbeleggen-online-vermogensbeheer-2021.pdf"
            target="_blank"
          >
            <awesomeIcon icon="file-pdf"/>
            <h4>U stelt het doel, wij beleggen ernaartoe</h4>
          </a>
        </div>
        <div class="card">
          <a
            href="https://www.doelbeleggen.nl/content/uploads/br_doelbeleggen_pensioen_202201.pdf"
            target="_blank"
          >
            <awesomeIcon icon="file-pdf"/>
            <h4>Box 1 lijfrente opbouwen</h4>
          </a>
        </div>
        <div class="card">
          <a
            href="https://www.doelbeleggen.nl/content/uploads/Doelbeleggen-brochure-uitkerende-lijfrente-8-21.pdf"
            target="_blank"
          >
            <awesomeIcon icon="file-pdf"/>
            <h4>Box 1 lijfrente uitkeren</h4>
          </a>
        </div>
        <div class="card">
          <a
            href="https://www.doelbeleggen.nl/content/uploads/Factsheet-Leefrente-202102.pdf"
            target="_blank"
          >
            <awesomeIcon icon="file-pdf"/>
            <h4>Lijfrente uitkeren - factsheet</h4>
          </a>
        </div>
        <div class="card">
          <a
            href="https://www.doelbeleggen.nl/content/uploads/Sparen-of-beleggen-wat-is-uw-keuze-1.pdf"
            target="_blank"
          >
            <awesomeIcon icon="file-pdf"/>
            <h4>Sparen of beleggen, wat is uw keuze</h4>
          </a>
        </div>
        <div class="card">
          <a
            href="https://www.doelbeleggen.nl/content/uploads/Doelbeleggen-Finner-Beoordeling-2021.pdf"
            target="_blank"
          >
            <awesomeIcon icon="file-pdf"/>
            <h4>Beoordelingsrapport 2021 finner.nl</h4>
          </a>
        </div>
        <div class="card">
          <a
            href="https://www.doelbeleggen.nl/content/uploads/Doelbeleggen-goudenhanddruk-12-2021.pdf"
            target="_blank"
          >
            <awesomeIcon icon="file-pdf"/>
            <h4>Uitkering gouden handdruk / stamrecht</h4>
          </a>
        </div>
        <div class="card">
          <a
            href="https://www.doelbeleggen.nl/content/uploads/Doelbeleggen-ODV-Brochure.pdf"
            target="_blank"
          >
            <awesomeIcon icon="file-pdf"/>
            <h4>Uitkeren odv - oudedagsverplichting</h4>
          </a>
        </div>
      </div>

        <!-- Formulieren en document-->
      <div class="row titleOption">
        <h2>Formulieren en documenten</h2>
      </div>
      <div class="container">
        <div class="card">
          <a
            href="https://www.doelbeleggen.nl/content/uploads/2019/07/Voorwaarden_doelbeleggen_pensioenrekening_v201907.pdf"
            target="_blank"
          >
            <awesomeIcon icon="file-pdf"/>
            <h4>Voorwaarden pensioenrekening</h4>
          </a>
        </div>
        <div class="card">
          <a
            href="https://www.doelbeleggen.nl/content/uploads/Handleiding-machtigingen.pdf"
            target="_blank"
          >
            <awesomeIcon icon="file-pdf"/>
            <h4>Handleiding klant openen en koppelen</h4>
          </a>
        </div>
        <div class="card">
          <a
            href="https://www.doelbeleggen.nl/content/uploads/Voorwaarden-Leefrente.pdf"
            target="_blank"
          >
            <awesomeIcon icon="file-pdf"/>
            <h4>Voorwaarden leefrente</h4>
          </a>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'DocCenter',
  data() {
    return {
      style: process.env.VUE_APP_STYLE,
      brochureFiles: [
        {
          url: 'https://www.doelbeleggen.nl/content/uploads/Samen-Doelbeleggen.pdf',
          title: 'Samen Doelbeleggen - algemene informatie',
        },
        {
          url: 'https://www.doelbeleggen.nl/content/uploads/Doelbeleggen-online-vermogensbeheer-2021.pdf',
          title: 'Doelbeleggen.nl algemene informatie',
        },
        {
          url: 'https://www.doelbeleggen.nl/content/uploads/2022-beoordeling-vergelijk-ervaring-met-Doelbeleggen.pdf',
          title: 'Beoordelingsrapport Finner 2022',
        },
        {
          url: 'https://www.doelbeleggen.nl/content/uploads/Voorwaarden-Beleggingsrekening.pdf',
          title: 'Voorwaarden beleggingsrekening',
        },
        {
          url: 'https://www.doelbeleggen.nl/content/uploads/Voorwaarden-Doelbeleggen.pdf',
          title: 'Voorwaarden Doelbeleggen.nl',
        },
        {
          url: 'https://www.doelbeleggen.nl/content/uploads/Samen-Doelbeleggen-Gebruiksvoorwaarden.pdf',
          title: 'Samen Doelbeleggen - Gebruiksvoorwaarden',
        },
        {
          url: 'https://www.doelbeleggen.nl/content/uploads/Samen-Doelbeleggen-Pensioenwijzer.pdf',
          title: 'Samen Doelbeleggen - Pensioenwijzer',
        },
        {
          url: 'https://www.doelbeleggen.nl/content/uploads/Samen-Doelbeleggen-Bankgegevens.pdf',
          title: 'Samen Doelbeleggen - Bankgegevens',
        },
        {
          url: 'https://www.doelbeleggen.nl/content/uploads/Samen-Doelbeleggen-Duurzaamheid.pdf',
          title: 'Samen Doelbeleggen - Duurzaamheid',
        },
        {
          url: 'https://www.doelbeleggen.nl/content/uploads/Samen-Doelbeleggen-Indicatieve-portefeuille-Doelbeleggen-A.pdf',
          title: 'Samen Doelbeleggen - Indicatieve portefeuille DB A',
        },
        {
          url: 'https://www.doelbeleggen.nl/content/uploads/Samen-Doelbeleggen-Indicatieve-portefeuille-Doelbeleggen-B.pdf',
          title: 'Samen Doelbeleggen - Indicatieve portefeuille DB B',
        },
        {
          url: 'https://www.doelbeleggen.nl/content/uploads/Samen-Doelbeleggen-Indicatieve-portefeuille-Doelbeleggen-C.pdf',
          title: 'Samen Doelbeleggen - Indicatieve portefeuille DB C',
        },
        {
          url: 'https://www.doelbeleggen.nl/content/uploads/Samen-Doelbeleggen-Indicatieve-portefeuille-Doelbeleggen-D.pdf',
          title: 'Samen Doelbeleggen - Indicatieve portefeuille DB D',
        },
        {
          url: 'https://www.doelbeleggen.nl/content/uploads/Samen-Doelbeleggen-Indicatieve-portefeuille-Doelbeleggen-E.pdf',
          title: 'Samen Doelbeleggen - Indicatieve portefeuille DB E',
        },
        // {
        //   url: '',
        //   title: 'Samen Doelbeleggen - Handleiding',
        // },
      ],
      annuitiesFiles: [
        {
          url: 'https://www.doelbeleggen.nl/content/uploads/br_doelbeleggen_pensioen_202201.pdf',
          title: 'Box 1 lijfrente – opbouw',
        },
        {
          url: 'https://www.doelbeleggen.nl/content/uploads/Doelbeleggen-brochure-uitkerende-lijfrente-8-21.pdf',
          title: 'Box 1 lijfrente – uitkeren',
        },
        {
          url: 'https://www.doelbeleggen.nl/content/uploads/2019/07/Voorwaarden_doelbeleggen_pensioenrekening_v201907.pdf',
          title: 'Voorwaarden pensioenrekening',
        },
        {
          url: 'https://www.doelbeleggen.nl/content/uploads/Voorwaarden-Leefrente.pdf',
          title: 'Voorwaarden uitkerende beleggingslijfrente',
        },
        {
          url: 'https://www.doelbeleggen.nl/content/uploads/Voorwaarden-Netto-Leefrente.pdf',
          title: 'Voorwaarden netto leefrente',
        },
        {
          url: 'https://www.doelbeleggen.nl/content/uploads/Doelbeleggen-ODV-Brochure.pdf',
          title: 'Doelbeleggen.nl - Oudedagsverplichting (ODV)',
        },
        {
          url: 'https://www.doelbeleggen.nl/content/uploads/doelbeleggen-ondernemerspensioen.pdf',
          title: 'Ondernemerspensioen',
        },
      ],
      goldenHandshakeFiles: [
        {
          url: 'https://www.doelbeleggen.nl/content/uploads/Doelbeleggen-goudenhanddruk-12-2021.pdf',
          title: 'Gouden Handdruk/Stamrecht',
        },
        {
          url: 'https://www.doelbeleggen.nl/content/uploads/Voorwaarden-Gouden-handdruk.pdf',
          title: 'Voorwaarden Gouden Handdruk',
        },
      ],
    };
  },
  computed: {
    role() {
      return this.$store.state.role;
    },
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
.titleOption {
  background: #e9ecf2;
  color: $color-background;
  padding-left: 20px;
  padding-bottom: 10px;
  margin-bottom: 5px;
  padding-top: 1px;
}
.container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  @media #{$mobile} {
    flex-direction: column;
  }
  &::after {
    display: none;
  }
  .card {
    @media screen and (min-width: 800px) {
      width: 99%;
    }
    @media screen and (min-width: 940px) {
      width: 49%;
    }
    box-sizing: border-box;
    // padding-bottom: 1%; /* Same as width, sets height */
    position: relative;
  }
}
.card {
  padding: 20px !important;
  padding-top: 10px !important;
  margin-bottom: 5px; /* (100-32*3)/2 */
  svg {
    width: 30px;
    height: 30px;
    display: block;
    color: $color-highlight;
    transition: color .2s;
    float: right;
  }
}
</style>
